import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const getLanguageKey = () => {
  const lang = localStorage.getItem("language");
  switch (lang) {
    case "VND":
      return "vn";
    case "THB":
      return "th";
    case "SGP":
      return "sg";
    case "IDR":
      return "id";
    case "PHP":
      return "ph";
    default:
      return "en";
  }
};

const initI18n = () => {
  const langKey = getLanguageKey();
  i18n
    .use(initReactI18next)
    .init({
      fallbackLng: langKey,
      lng: langKey,
      resources: {
        en: {
          translations: require("./locales/en/translations.json"),
        },
        vn: {
          translations: require("./locales/vn/translations.json"),
        },
        th: {
          translations: require("./locales/th/translations.json"),
        },
        sg: {
          translations: require("./locales/sg/translations.json"),
        },
        id: {
          translations: require("./locales/id/translations.json"),
        },
        ph: {
          translations: require("./locales/ph/translations.json"),
        },
      },
      ns: ["translations"],
      defaultNS: "translations",
    });
  i18n.languages = ["en", "vn", "th", "sg", "id", "ph"];
};

// First run
initI18n();

// Re-run after 500ms
setTimeout(() => {
  initI18n();
}, 1000);

export default i18n;
